import React, { Fragment, Component } from 'react'
import injectSheet from 'react-jss'
import styles from './discussion-feed.styles'
import Action from './action/action.container'
import Button from 'pobble-components/dist/button'
import ArrowIcon from 'react-icons/lib/fa/refresh'
import EditContributionDialog from './action/action-comment/context-menu/edit-contribution-dialog/edit-contribution-dialog.container'

class DiscussionFeed extends Component {
  componentDidMount() {
    this.props.onMount(this.props.id)
  }
  render() {
    const { classes, pending, contributions } = this.props
    return (
      <Fragment>
        {!pending && (
          <div className={classes.refreshContainer}>
            <Button
              simple
              className={classes.refresh}
              action={() => this.props.onMount(this.props.id)}>
              <ArrowIcon /> Refresh
            </Button>
          </div>
        )}
        <ul className={classes.container}>
          {!pending &&
            contributions &&
            contributions.map(contribution => (
              <Action key={contribution.id} id={contribution.id} />
            ))}
        </ul>
        {!pending && contributions.length === 0 && <p>No contributions yet.</p>}
        <EditContributionDialog />
      </Fragment>
    )
  }
}

export default injectSheet(styles)(DiscussionFeed)
